export default __webpack_public_path__ + "static/media/pustack_tutor_color_logo.9416d409.png";